import React, { Component, Suspense } from "react";
import AppNavBar from "./navbar";
import AppContainer from "./appcontainer";

import { Switch, Route, Redirect } from "react-router-dom";

import { Modal } from "react-bootstrap";
import { closeModal } from "../../store/actions/ModalActions";

import DashboardLoader from "../extensions/DashboardLoader";

import { connect } from "react-redux";
import { ErrorPage } from "../extensions";
import { repair } from "../../images";

import Pawnshop_Dashboard from "../../screens/pawnshop_dashboard";
import ReportsDefaultView from "../../screens/pawnshop_reports/reports_default";

import history from "../../history";

import { Zoom } from "react-preloaders";

import DailyReportsViewLayout from "../../screens/pawnshop_reports/daily/DailyReportsViewLayout";
import ProfitBreakdownViewLayout from "../../screens/pawnshop_reports/profit_breakdown/ProfitBreakdownViewLayout";
import InventoryDetailsViewLayout from "../../screens/pawnshop_reports/inventory_details/InventoryDetailsViewLayout";

import SettingsDefault from "../../screens/pawnshop_settings/settings_default";
import BranchCategorySettings from "../../screens/pawnshop_settings/branch_category/branch_category_settings";
import InventoryTargetSettingsLayout from "../../screens/pawnshop_settings/inventory_targets/inventory_target_layout";
import {  Container, Button } from "react-bootstrap";

class PageLayout extends Component {
  state = {};

  renderPageNoContent = () => {
    return (
      <div>
        <ErrorPage
          description="The page you are looking for was moved, removed, renamed or might never existed."
          title="Error 404"
          img={repair}
          options={
            <div>
              <Button
                variant="dark"
                size="sm"
                onClick={() => {
                  history.goBack();
                }}
              >
                Go Back
              </Button>
            </div>
          }
        />
      </div>
    );
  };

  renderAllowedAppContent = () => {
    return (
      <div className="mt-4" style={{ overflow: "auto" }}>
        <Suspense fallback={<Zoom background="blur" />}>
          <Switch>
            <Route
              path="/pawnshop-reports"
              exact={true}
              component={Pawnshop_Dashboard}
            />

            <Route
              path="/pawnshop-reports/dashboard"
              exact={true}
              component={Pawnshop_Dashboard}
            />

            <Route
              path={`/pawnshop-reports/reports`}
              exact={true}
              component={ReportsDefaultView}
            />
            <Route
              path={`/pawnshop-reports/daily-reports`}
              exact={true}
              component={DailyReportsViewLayout}
            />
            <Route
              path={`/pawnshop-reports/profit-breakdown`}
              exact={true}
              component={ProfitBreakdownViewLayout}
            />
            <Route
              path={`/pawnshop-reports/inventory-details`}
              exact={true}
              component={InventoryDetailsViewLayout}
            />

            <Route
              path={`/pawnshop-reports/settings`}
              exact={true}
              component={SettingsDefault}
            />
            <Route
              path={`/pawnshop-reports/branch-categories`}
              exact={true}
              component={BranchCategorySettings}
            />
            <Route
              path={`/pawnshop-reports/target`}
              exact={true}
              component={InventoryTargetSettingsLayout}
            />

            <Redirect from="/" to="/pawnshop-reports" />
            <Route path="*" component={this.renderPageNoContent} />
          </Switch>
        </Suspense>

        <Modal
          dialogClassName={
            this.props.customModal === true ? "custom-dialog" : ""
          }
          size={this.props.modalSize}
          backdrop="static"
          show={this.props.modalIsOpen}
          onHide={() => this.props.CloseModal()}
        >
          <Modal.Header closeButton>
            <Modal.Title>{this.props.modalTitle}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Container fluid>{this.props.currentModalComponent}</Container>
          </Modal.Body>
        </Modal>
      </div>
    );
  };

  render() {
    return (
      <div>
        <AppNavBar />
        {!this.state.isLoading ? (
          <AppContainer>{this.renderAllowedAppContent()}</AppContainer>
        ) : (
            <>
              <DashboardLoader animation="border" />
            </>
          )}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    allowDetailDisplay: state.keycloak.allowedToDisplayDetails,
    customModal: state.modal.Config.custom,
    modalIsOpen: state.modal.Config.isModalOpen,
    modalTitle: state.modal.Config.title,
    modalSize: state.modal.Config.size,
    currentModalComponent: state.modal.Config.currentComponent,
  };
};

const mapDispatchToProps = {
  CloseModal: closeModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(PageLayout);
